import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(({ typography }) => ({
    wireTransferGuide: {
        marginBottom: '30px',
    },
  subHeading: {
    fontFamily: typography.fontFamilySecondary,
    fontSize: '12px',
    fontWeight: typography.fontWeightSemiBold,
    marginTop: '2.4em',
    marginBottom: '0.2em',
  },
}), { name: 'SendPaymentsStyles' });

export default useStyles;